import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">My Bridal Photos</p>
        <h1>Capture Your Love Story</h1>
        <p className="lede">
          At My Bridal Photos, we specialize in creating stunning, timeless photography that celebrates your unique journey. Let us help you preserve the magic of your special day.
        </p>
        <div className="cta-row">
          <a href="/portfolio" target="_self">
            View Our Portfolio
          </a>
          <a href="/contact" target="_self" className="secondary">
            Get in Touch
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Elegant Photography</h2>
          <p>
            Our team captures every moment with artistry and precision, ensuring that your memories are beautifully documented.
          </p>
        </article>
        <article>
          <h2>Personalized Experience</h2>
          <p>
            We work closely with you to understand your vision, tailoring our services to meet your specific needs and preferences.
          </p>
        </article>
        <article>
          <h2>Seamless Delivery</h2>
          <p>
            Enjoy a hassle-free experience with timely delivery of your photos, allowing you to relive your special day without delay.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;